import { AppointmentSchedulingConfiguration } from '../../config/appointment_scheduling_configuration';
import {
  IAppointmentsTabsConfiguration,
  IAppointmentsTabsConfigurationDataType,
  IAppointmentsTabsConfigurationOptions
} from '../../servants/appointments_tabs_configuration';
import MyAppointmentStateService from '../../services/my_appointment_state_service';

export class AppointmentsController {
  constructor(
    private ngAppointmentsTabsConfiguration: IAppointmentsTabsConfiguration,
    private appConfigModel: any,
    private ngMyAppointmentsStateService: MyAppointmentStateService,
    private ngAppointmentSchedulingConfiguration: AppointmentSchedulingConfiguration
  ) {}

  get tabs(): IAppointmentsTabsConfigurationDataType {
    const tabs = this.ngAppointmentsTabsConfiguration.read();
    for (const index in tabs) {
      const step = tabs[index];
      step.isActive = this.ngMyAppointmentsStateService.isCurrentState(step.state);
    }
    return tabs;
  }

  progressStyle(step: any, index: number) {
    if (step.isActive) {
      return 'text-bold clr-blue_30-txt clr-blue_30-bdr is-active';
    } else {
      return step.isCompleted ? 'clr-blue_30-bdr' : 'clr-gray_30-bdr';
    }
  }
}

angular.module('capability-ng-appointments').controller('ngAppointmentsController', AppointmentsController);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/views/appointments/appointments.ts